import Vue from 'vue'
import defaultState from './state'
export default {
  setIsCallingCustomers: (state, payload) => { state.isCallingCustomers = payload },
  setCustomers: (state, payload) => {
    if (state.currentPage === 1) {
      state.customers = payload
    } else {
      state.customers.push(...payload)
    }
  },
  setCustomersFilters: (state, payload) => { state.filters = payload },
  setCustomersLastPage: (state, payload) => { state.lastPage = payload },
  setCustomersTotalItems: (state, payload) => { state.totalItems = payload },
  incrementCustomersCurrentPage: state => state.currentPage++,
  // Update Customer Mutation should be used for both archive and update user data, otherwise a delete should be implemented
  updateCustomer: (state, payload) => {
    const { id } = payload
    const customerToUpdateIndex = state.customers.findIndex(el => el.id === id)
    if (customerToUpdateIndex !== -1) {
      state.customers.splice(customerToUpdateIndex, 1, payload)
    }
  },
  addError: (state, payload) => { state.errors.push(payload) },
  clearErrors: state => { state.errors = [] },
  clearCustomers: (state, payload) => { state.customers = [] },
  clearStoreData: state => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      Vue.set(state, key, initialState[key])
    })
  }
}
